import React from 'react';
import moment from 'moment';
import { WorkingTime } from 'src/components';
import { getNormalizedPeriods, getTimeStr } from 'src/utils/calendar';

import { workingTimeColor } from '../../../../../constants/colors';
import { WorkingTimeMenuIcon } from '../../../../../Icons';
import {
  SectionBottomContainer,
  SectionContainer,
  SectionEmptyBlock,
  SectionHeader,
  SectionLabel,
  SectionWrapper,
} from '../common';

import { TimeListSection } from './components/TimeListSection';

interface WorkingTimeSectionProps {
  workingTimes?: Array<WorkingTime>;
  onClick?: () => void;
}

export const WorkingTimeSection = ({
  workingTimes,
  onClick,
}: WorkingTimeSectionProps) => {
  const renderWorkingTimes = () => {
    return workingTimes?.map(({period, daysPeriods}) => {
      const fromDateText = moment(period.from).format('DD.MM.YY');
      const periodText = `${moment(period.from).format('MMM YY')} - ${moment(period.to).format('MMM YY')}`;

      const periodsNormalized = getNormalizedPeriods(daysPeriods);

      const renderPeriods = () => {
        return Object.entries(periodsNormalized).map(([key, value]: any) => {
          const [from, to] = key.split('/');
          const weekdays = value.weekdays.join(', ');

          return (
            <TimeListSection
              from={from}
              to={to}
              weekdays={weekdays}
            />
          );
        });
      }

      return (
        <SectionContainer
          onClick={onClick}
          color={workingTimeColor}
        >
          <>
            <SectionHeader
              label="Regular hours"
            />
            {renderPeriods()}
            <SectionBottomContainer
              labelLeft="From"
              labelRight="Period"
              textLeft={fromDateText}
              textRight={periodText}
            />
          </>
        </SectionContainer>
      );
    })
  }

  return (
    <SectionWrapper>
      <>
        <SectionLabel
          Icon={WorkingTimeMenuIcon}
          label="Working Time"
        />
        {
          workingTimes?.length
            ? renderWorkingTimes()
            : <SectionEmptyBlock/>
        }
      </>
    </SectionWrapper>
  );
};
